// Ask Ogma (Craig, 31 Oct 2026; docs/specs/CAMPAIGN_LED_2026_10.md): where the app opens. One page, like Claude: the
// conversation with Ogma, with tables, charts, drafts and pages opening in the side window beside it. It replaced Home
// and, at /ask/table, Ask the CRM; the menu shows what needs you beside each place.
// Screens are loaded with screen() (see ./screen.ts), never imported directly.
import type { FlatModule } from "./types";
import { screen } from "./screen";

const AskOgma = screen(() => import("../screens/AskOgma"), "AskOgma");
const SourceSuggestionsPage = screen(() => import("../screens/ogma/SourceSuggestions"), "SourceSuggestionsPage");

export const ask: FlatModule = {
  key: "ask",
  label: "Ask Ogma",
  layout: "flat",
  items: [{ path: "/ask", label: "Ask Ogma", render: () => <AskOgma /> }],
  extraPages: [
    // L-13 Ogma's team only: answer businesses' "Suggest a place to look" (the database refuses other workspaces).
    { path: "/ogma/suggestions", label: "Source suggestions", render: () => <SourceSuggestionsPage /> },
  ],
  taskHomes: {},
};
